<template>
  <div class="card p-4">
    <div class="col-12 d-md-flex justify-content-lg-between mb-3 clickable" @click.prevent="toggle">
      <h4>
        <span class="badge badge-danger">
          <b>{{ showing ? "--":"+"}}</b>
        </span> Midias do Curso
      </h4>
    </div>

    <div class="collapse show" id="collapse-media">
      <div class="row">
        <div class="col-12">
          <media-item
            title="Imagem de Capa"
            modal="uploadCoverClassModal"
            class="mb-2 item-media"
            @setItemValue="setCover"
            :itemDefault="medias.cover"
          />
        </div>

        <div class="col-12">
          <media-item
            title="Miniatura"
            modal="uploadThumbnailClassModal"
            class="mb-2 item-media"
            @setItemValue="setThumbnail"
            :itemDefault="medias.thumbnail"
          />
        </div>

        <div class="col-12">
          <media-item
            title="Vídeo Promocional"
            modal="uploadVideoClassModal"
            class="mb-2 item-media"
            @setItemValue="setVideo"
            :itemDefault="medias.video"
          />
        </div>

        <div class="col-12 text-right">
          <button class="btn btn-success" @click="save">Salvar Midias</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Form } from "vform";
import MediaItem from "./../../../Media/LoadItemMedia";

export default {
  props: {
    medias: {
      required: true
    },
    course: {
      required: true
    }
  },
  components: {
    "media-item": MediaItem
  },
  data() {
    return {
      showing: true,
      form: new Form({
        id: undefined,
        picture_cover: undefined,
        picture_thumbnail: undefined,
        promotional_video: undefined
      })
    };
  },
  methods: {
    setCover: function(item) {
      this.form.picture_cover = item.id;
    },
    setThumbnail: function(item) {
      this.form.picture_thumbnail = item.id;
    },
    setVideo: function(item) {
      this.form.promotional_video = item.id;
    },
    save: function() {
      this.form.id = this.course;
      this.form
        .post("/teacher/course/media")
        .then(res => {
          Swal.fire({
            icon: "success",
            text: "Informações atualizadas",
            title: "Sucesso"
          });
          this.load();
        })
        .catch(err => {
          console.error(err);
        });
    },
    toggle: function() {
      this.showing = !this.showing;
      $("#collapse-media").collapse("toggle");
    }
  }
};
</script>
